export { default as Header } from "./Header";
export { default as Body } from "./Body";
export { default as Footer } from "./Footer";
export { default as LowerBody } from "./LowerBody";



// WEBPACK FOOTER //
// ./src/pages/Home/components/index.js